module.exports = __webpack_public_path__ + "static/media/ICON_MORE.0dcb8efe.svg";